import { render, staticRenderFns } from "./Financedept.vue?vue&type=template&id=55161230&scoped=true"
import script from "./Financedept.vue?vue&type=script&lang=js"
export * from "./Financedept.vue?vue&type=script&lang=js"
import style0 from "./Financedept.vue?vue&type=style&index=0&id=55161230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55161230",
  null
  
)

export default component.exports